import { List } from '@mui/material';
import { styled } from '@mui/material/styles';

import { OPENED_CONTENT_WIDTH } from 'applications/GSP/layouts/MainLayout/components/Sidebar/constants';

export const NavigationList = styled(List)(({ theme }) => ({
  width: OPENED_CONTENT_WIDTH,
  padding: 0,
  margin: theme.spacing(0.625, 'auto', 0),
  border: 'none',
  alignSelf: 'flex-start',
  justifySelf: 'center',
}));
